const Calendar = () => import('@/views/Application/Calendar/Calendar');

export default [
  {
    path: '/dashboard/calendar',
    name: 'calendar',
    component: Calendar,
    meta: {
      requiresAuth: true,
    },
  },
];
